import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

import { TBotItem } from '@core/interfaces/TBotItem';

import { ApiConversationService } from '../../api/services/agents/api-conversations.service';
import { Conversation } from '../infrastructure/models/Conversation';
import { ConversationAdapterService } from './adapters/conversation-adapter.service';
import { ConversationDataService } from './conversation-data.service';
import { FeatureService } from '@shared/services/feature.service';

import { HistoryAdapter } from './adapters/history.adapter';

@Injectable({
  providedIn: 'root',
})
export class HistoryConversationService {
  private _activeRequest: Subscription | null = null;
  private _requestToken = 0;

  constructor(
    private _apiConversationService: ApiConversationService,
    private _conversationDataService: ConversationDataService,
    private _conversationAdapterService: ConversationAdapterService,
    private _featureService: FeatureService
  ) {}

  getConversationById(conversationId: string, callback?: () => void, errorCallback?: () => void) {
    this.cancelActiveRequest();

    const isBotUiConfigEnabled = this._featureService.isEnabled('bot-ui-config');
    this._conversationAdapterService.setAdapter(new HistoryAdapter(isBotUiConfigEnabled));

    const token = ++this._requestToken;
    this._activeRequest = this._apiConversationService.getHistoryConversation(conversationId).subscribe({
      next: res => {
        if (token !== this._requestToken) {
          return;
        }
        const conv = this._conversationAdapterService.adapt(
          res,
          new Conversation({
            id: conversationId,
            type: 'results',
            bot: { _id: res.botID } as TBotItem,
          })
        );
        this._conversationDataService.emitNext(conv);
        if (callback) callback();
      },
      error: err => {
        if (token !== this._requestToken) {
          return;
        }
        console.error('Error loading conversation history:', err);
        errorCallback?.();
      },
      complete: () => {
        if (token === this._requestToken) {
          this._activeRequest = null;
        }
      },
    });
  }

  /** Cancel in-flight history fetch so late responses cannot repopulate dashboard state. */
  cancelActiveRequest(): void {
    this._requestToken++;
    this._activeRequest?.unsubscribe();
    this._activeRequest = null;
  }
}
